import { Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import Button from "./Button";
import RemoveIcon from "@mui/icons-material/Remove";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";
import {
  useSendProductJobDetailsMutation,
  useUpdateCartMutation,
} from "../reducer/productReducer";

const CardDescription = React.forwardRef((props, ref) => {
  const { existingJobList, productList } = props;
  const [addedCardList, setAddedCardList] = useState();
  const [newProductsArr, setNewProductsArr] = useState([]);
  const [cartCount, setCartCount] = React.useState(0);
  const [productData, setProductData] = useState();
  const navigate = useNavigate();
  let NewProductList;

  useEffect(() => {
    if (existingJobList && existingJobList[0] && existingJobList[0].products) {
      try {
        let ExisPD = existingJobList[0].products;
        let newCmpArr;
        
        if (productData && Array.isArray(productData)) {
          let AfterCmprPDData = productData.map((data) => {
            if (!data || !data.products || !Array.isArray(data.products)) {
              return data;
            }
            
            const compareArr = data.products.map((pdVal) => {
              newCmpArr = ExisPD.find((x) => x.productId === pdVal.productId);
              if (newCmpArr) {
                return { ...pdVal, quantity: newCmpArr.count, show: true };
              }
              return pdVal;
            });
            
            return { ...data, products: compareArr };
          });
          
          setProductData(AfterCmprPDData);
        }
        
        setAddedCardList(existingJobList);
        calculateCountFun(existingJobList[0].products);
      } catch (error) {
        console.error("Error processing existing job list:", error);
      }
    }
  }, [existingJobList]);

  useEffect(() => {
    if (productList && Array.isArray(productList)) {
      try {
        NewProductList = productList.map((JobCategory) => {
          if (!JobCategory || !JobCategory.products || !Array.isArray(JobCategory.products)) {
            return JobCategory;
          }
          
          let products = JobCategory.products.map((item) => {
            return {
              ...item,
              quantity: 1,
              show: false
            };
          });
          
          return {
            ...JobCategory,
            products: products,
          };
        });
        
        setProductData(NewProductList);
      } catch (error) {
        console.error("Error processing product list:", error);
      }
    }
  }, [productList]);

  const [updateCartAPI] = useUpdateCartMutation();
  const [addCartAPI] = useSendProductJobDetailsMutation();

  async function viewCartFunc() {
    try {
      if (addedCardList && addedCardList[0] && addedCardList[0].id) {
        let Id = addedCardList[0].id;
        let paramsData = addedCardList[0];
        
        try {
          const response = await updateCartAPI({ Id, paramsData });
          if (response.data) {
            let resData = response.data;
            navigate("/cart", { state: resData });
          }
        } catch (err) {
          console.error("Error updating cart:", err);
        }
      } else if (newProductsArr && newProductsArr.length > 0) {
        let newPostArr = {
          status: "DRAFT",
          products: newProductsArr,
        };
        
        try {
          const response = await addCartAPI(newPostArr);
          if (response.data) {
            let resData = response.data;
            navigate("/cart", { state: resData });
          }
        } catch (err) {
          console.error("Error creating cart:", err);
        }
      } else {
        console.error("No items to add to cart");
      }
    } catch (error) {
      console.error("Error in viewCartFunc:", error);
    }
  }

  function calculateCountFun(items) {
    // Handle null, undefined, or non-array items
    if (!items || !Array.isArray(items)) {
      setCartCount(0);
      return;
    }
    
    let cartCnt = 0;
    
    items.forEach((item) => {
      // Check if item has count property before adding
      cartCnt = cartCnt + (item.count || 0);
    });
    
    setCartCount(cartCnt);
  }

  function addCardCountFunc(cnt, pdata, jbCtgry) {
    try {
      if (addedCardList?.length) {
        let copyExistingJobLst = [...addedCardList];
        
        if (!copyExistingJobLst[0] || !copyExistingJobLst[0].products) {
          console.error("Invalid cart data structure");
          return;
        }
        
        let copyProductList = [...copyExistingJobLst[0].products];
        let updateValuesArr = updateCountInListFun(
          copyProductList,
          pdata,
          cnt,
          jbCtgry
        );
        
        let newCmpArr;
        let AfterCmprPDData = copyExistingJobLst.map((data) => {
          if (!data || !data.products) return data;
          
          const compareArr = data.products.map((pdVal) => {
            newCmpArr = updateValuesArr.find(
              (x) => x.productId === pdVal.productId
            );
            if (newCmpArr) {
              return { ...pdVal, count: newCmpArr.count };
            }
            return pdVal;
          });
          
          return { ...data, products: compareArr };
        });
        
        setAddedCardList(AfterCmprPDData);
        calculateCountFun(updateValuesArr);
      } else {
        if (newProductsArr?.length) {
          let updateValuesArr = updateCountInListFun(
            newProductsArr,
            pdata,
            cnt,
            jbCtgry
          );
          
          setNewProductsArr(updateValuesArr);
          calculateCountFun(updateValuesArr);
        } else {
          let products = [];
          let newPd = {
            productId: pdata.productId,
            count: cnt,
            title: pdata.title,
            categoryId: jbCtgry.id,
            categoryTitle: jbCtgry.title,
          };
          
          products.push(newPd);
          setNewProductsArr(products);
          calculateCountFun(products);
        }
      }
    } catch (error) {
      console.error("Error in addCardCountFunc:", error);
    }
  }

  function updateCountInListFun(pdArray, pdata, cnt, jbCtgry) {
    if (!pdArray || !Array.isArray(pdArray)) {
      return [];
    }
    
    try {
      let makeNewPdArr = [...pdArray];
      var filterPdObj = makeNewPdArr.find((d) => d.productId === pdata.productId);
      
      if (!filterPdObj) {
        let newPdObj = {
          productId: pdata.productId,
          count: cnt,
          title: pdata.title,
          categoryId: jbCtgry.id,
          categoryTitle: jbCtgry.title,
        };
        
        makeNewPdArr.push(newPdObj);
      } else {
        var newObj = { ...filterPdObj };
        newObj.count = cnt;
        
        let getIndx = makeNewPdArr.findIndex(
          (x) => x.productId === newObj.productId
        );
        
        if (getIndx !== -1) {
          makeNewPdArr[getIndx] = newObj;
        }
      }
      
      return makeNewPdArr;
    } catch (error) {
      console.error("Error in updateCountInListFun:", error);
      return pdArray || [];
    }
  }

  return (
    <div
      style={{
        overflowY: "scroll",
        height: "45vh",
        marginLeft: "-3%",
        marginRight: "-3%",
        paddingBottom: "10vh",
      }}
    >
      {productData && Array.isArray(productData) ? (
        productData.map((JobCategory, index) => {
          if (!JobCategory) return null;
          
          return (
            <div 
              className="jobDesc" 
              key={JobCategory.id || index}
              ref={ref && ref[JobCategory.id]}
            >
              <Typography
                style={{
                  fontWeight: "600",
                  fontSize: "18px",
                  marginTop: "4%",
                  marginLeft: "2%",
                }}
              >
                {JobCategory?.title}
              </Typography>
              <br />
              {JobCategory?.products && Array.isArray(JobCategory.products) ? (
                JobCategory.products.map((item, index) => {
                  if (!item) return null;
                  
                  return (
                    <Grid style={{ zIndex: "5" }} key={item?.id || index}>
                      <Grid
                        borderRadius="6px"
                        sx={{
                          border: "2px solid #e3e3e3",
                          display: "flex",
                          position: "relative",
                          boxShadow: "0px 3px 3px #7E7E7E29",
                        }}
                        width="100%"
                        height="160px"
                        padding="2vh"
                      >
                        <Grid width="36%" paddingRight="4%">
                          <img
                            style={{
                              height: "100%",
                              width: "100%",
                            }}
                            src={item.image}
                            alt="pic"
                          />
                        </Grid>
                        <Grid width="64%">
                          <Typography
                            style={{ fontSize: "16px", fontWeight: "600" }}
                          >
                            {item.title}
                          </Typography>
                          <Typography
                            id="three-lines-text-css"
                            style={{
                              lineHeight: "1.2",
                              color: "#535353",
                              fontSize: "13px",
                            }}
                          >
                            {item.description}
                          </Typography>
                          <Grid position="absolute" bottom="2vh">
                            {item.show === false ? (
                              <Button
                                width="50%"
                                color="greenBorder"
                                onClick={() => {
                                  const updatedItem = { ...item, show: true };
                                  addCardCountFunc(
                                    updatedItem.quantity + 0,
                                    updatedItem,
                                    JobCategory
                                  );
                                }}
                                name="Add Item"
                              />
                            ) : (
                              <Grid
                                display="flex"
                                padding="3px"
                                width="fit-content"
                                height="fit-content"
                                border="1px solid #0d4f57"
                                borderRadius="50px"
                                bgcolor="white"
                              >
                                <RemoveIcon
                                  onClick={() => {
                                    if (item.quantity > 1) {
                                      const newQuantity = item.quantity - 1;
                                      addCardCountFunc(
                                        newQuantity,
                                        item,
                                        JobCategory
                                      );
                                      // Update UI quantity
                                      item.quantity = newQuantity;
                                    }
                                  }}
                                  style={{
                                    paddingLeft: "15px",
                                    paddingRight: "10px",
                                    color: "#0d4f57",
                                  }}
                                />
                                <Typography>{item.quantity}</Typography>
                                <AddIcon
                                  onClick={() => {
                                    const newQuantity = item.quantity + 1;
                                    addCardCountFunc(
                                      newQuantity,
                                      item,
                                      JobCategory
                                    );
                                    // Update UI quantity
                                    item.quantity = newQuantity;
                                  }}
                                  style={{
                                    paddingRight: "15px",
                                    paddingLeft: "10px",
                                    color: "#0d4f57",
                                  }}
                                />
                              </Grid>
                            )}
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  );
                })
              ) : null}
            </div>
          );
        })
      ) : null}

      {cartCount > 0 ? (
        <Grid
          position="fixed"
          bottom="0"
          height="10vh"
          borderTop='1px solid grey'
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          style={{backgroundColor:'white', zIndex:'5'}}
          width="90%"
        >
          <Typography
            fontWeight="bold"
            style={{ fontSize: "16px", fontWeight: "normal" }}
          >
            Added {cartCount} items to cart
          </Typography>
          <Button
            color="green"
            onClick={viewCartFunc}
            name="View Cart"
          />
        </Grid>
      ) : null}
    </div>
  );
});

export default CardDescription;